import { apiAuth, apiResponseType } from ".";

export const getExpenseCategoriesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`expense-categories?page=${page}`);

export const selectExpenseCategoriesData = (): apiResponseType =>
  apiAuth.get(`expense-categories/select`);

export const searchExpenseCategoriesData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`expense-categories?name=${params.name}`);

export const storeExpenseCategoryData = (data: { name: string }) =>
  apiAuth.post("expense-categories/store", data) as apiResponseType;

export const updateExpenseCategoryData = (uuid: string, data: { name: string }) =>
  apiAuth.put(`expense-categories/${uuid}/update`, data) as apiResponseType;

export const deleteExpenseCategoryData = (uuid: string) =>
  apiAuth.delete(`expense-categories/${uuid}/destroy`) as apiResponseType;

export const toggleExpenseCategoryStatus = (uuid: string) =>
  apiAuth.put(`expense-categories/${uuid}/toggle-status`) as apiResponseType;

export const getShowExpenseCategory = (uuid: string) =>
  apiAuth.get(`expense-categories/${uuid}/show`) as apiResponseType; 